var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.208984C14.7384 0.208984 19 4.47054 19 9.70898C19 14.9474 14.7384 19.209 9.5 19.209C4.26155 19.209 0 14.9474 0 9.70898C0 4.47054 4.26155 0.208984 9.5 0.208984ZM9.5 17.9609C14.0497 17.9609 17.7519 14.2587 17.7519 9.70898C17.7519 5.15924 14.0497 1.45704 9.5 1.45704C4.95026 1.45704 1.24806 5.15924 1.24806 9.70898C1.24806 14.2587 4.95026 17.9609 9.5 17.9609Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81835 9.48371V4.47559C8.81835 4.13067 9.09746 3.85156 9.44238 3.85156C9.78729 3.85156 10.0664 4.13067 10.0664 4.47559V9.69475C10.0664 9.8309 10.021 9.96478 9.9382 10.0726L8.23743 12.3043C8.11489 12.4654 7.92882 12.5505 7.74048 12.5505C7.60886 12.5505 7.47612 12.5086 7.36266 12.4223C7.08808 12.2136 7.03589 11.8221 7.24466 11.5475L8.81721 9.48371H8.81835Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.798acea00f28ff5c152380e52c75092c.svg";
export { ForwardRef as ReactComponent };